export default "__VITE_ASSET__224698f8__"